import {Component, input} from '@angular/core';

@Component({
  selector: 'app-block-style-list',
  standalone: true,
  imports: [],
  templateUrl: './block-style-list.component.html',
  styleUrl: './block-style-list.component.css'
})
export class BlockStyleListComponent {
  data = input<any>();
}
